import React from "react";
import { Card } from "antd-mobile";
import CategoryMenu from "./CategoryMenu";
import DishesContext from "./DishesContext";
import Dishes from "./Dishes";
import AllergensContext from "./AllergensContext";
import TopMenu from "./TopMenu";
import SpiceLevelsContext from "../../../../DigitalMenu/SpiceLevelCtx";
import Newsletter from "../Newsletter";

function Body({ children, ...props }) {
  return (
    <DishesContext>
      <AllergensContext>
        <SpiceLevelsContext>
          <Card full className="restaurant-menu-body-card">
            <Card.Body>
              <TopMenu />
              <CategoryMenu />
              <Dishes />
            </Card.Body>
          </Card>
          <Newsletter />
        </SpiceLevelsContext>
      </AllergensContext>
    </DishesContext>
  );
}

export default Body;
